import React, { useContext, useEffect, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CartContext } from "./CartContext";
import "../css/paysuccess.css";

function PaymentStatus() {
  const [searchParams] = useSearchParams();
  const { clearCart } = useContext(CartContext);
  const successful = searchParams.get("state") === "success";
  const cleared = useRef(false);

  useEffect(() => {
    if (successful && !cleared.current) {
      cleared.current = true;
      clearCart();
    }
  }, [successful, clearCart]);

  return (
    <div className={`successDiv ${successful ? "is-success" : "is-cancel"}`}>
      <div className="success-container">
        <div className="modal-content">
          <div className="status-symbol" aria-hidden="true">{successful ? "✓" : "×"}</div>
          <h1>{successful ? "Payment received" : "Payment cancelled"}</h1>
          <p>
            {successful
              ? "Thank you. Your order is being reviewed and a confirmation will be sent to the email provided at checkout."
              : "No completed payment was recorded. Your cart is still available if you would like to try again."}
          </p>
          <Link className="status-link" to={successful ? "/shop" : "/checkout"}>
            {successful ? "Continue shopping" : "Return to checkout"}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default PaymentStatus;
